import React from 'react'

import Table from '../table'
import { Pagination } from '@st-operations/uikit/src/v2'
import { useState } from 'react'

const UrlSimilaritySeedTopUrls = ({ className, topUrls = [] }) => {
  const [page, setPage] = useState(0)

  return (
    <div className={className}>
      <div className="flex flex-row items-center gap-8 mb-4">
        <h3 className="m-0">Top URLs</h3>
      </div>
      <Table
        columns={[
          {
            className: 'text-gray-800',
            name: 'Canonical URL',
            key: 'canonicalUrl',
            styles: {
              width: '100%',
              textAlign: 'left',
            },
          },
          {
            className: 'text-gray-800',
            name: 'Score',
            key: 'score',
          },
          {
            className: 'text-gray-800',
            name: 'Users',
            key: 'userCount',
          },
        ]}
        data={topUrls
          .sort((a, b) => (a.userCount > b.userCount ? -1 : 1))
          .filter((_, index) => index >= page * 10 && index < (page + 1) * 10)}
      />
      <Pagination
        options={new Array(Math.floor(topUrls.length / 10) + 1).fill(0).map((_, index) => index)}
        page={page}
        onPageChange={(page) => {
          setPage(page.value)
        }}
      />
    </div>
  )
}

export default UrlSimilaritySeedTopUrls
